import { useEffect, useState } from "react"

import { BarChartOutlined } from "@ant-design/icons"
import { Flex, Space, Typography, Row, Col } from "antd"

import { ColorifiedButton } from "@/components/_Shared/Button/ColorifiedButton"
import { SimpleModal, SimpleModalRef } from "@/components/_Shared/SimpleModal"
import BulkOrderTimer from "@/components/BulkOrder/BulkOrderTimer/BulkOrderTimer"
import RequestQuoteInfo from "@/components/BulkOrder/RequestQuoteInfo/RequestQuoteInfo"

import classes from "./BulkOrderSummary.module.scss"

import { useBulkOrderMutation } from "@/hook/BulkOrders/useBulkOrderMutation"

import { IBulkOrderFuelCreate, IBulkOrderLog, BulkOrderLogEvent, IBulkOrderFuelLog } from "@/types/IBulkOrder"
const { Text } = Typography

export interface IBulkOrderSummaryProps {
  fuels: IBulkOrderFuelCreate[]
  logs: IBulkOrderLog[]
}

export const BulkOrderSummary = (props: IBulkOrderSummaryProps) => {
  const {
    fuels,
    logs
  } = props

  const onTheDateOfShipment = "на дату отгрузки"

  const getCurrentTotalQuantity = () => {
    return fuels.reduce((partialSum, a) => partialSum + Number(a.quantity), 0)
  }

  const getCurrentTotalOfferedPrice = () => {
    const prices = fuels.filter(x => x.offeredPrice)
    const isContainsUndefined = fuels.some(x => x.shippingSchedules?.map(y => y.price !== null ? y.price : undefined).includes(undefined))
    // eslint-disable-next-line max-len
    const sum = prices.reduce((partialSum, a) => partialSum + (a.shippingSchedules ? a.shippingSchedules.reduce((s, b) => s + (b.price ? Number(b.price) : 0) * b.quantity, 0) : 0), 0)

    if (!isContainsUndefined){
      return sum
    }

    if (!sum) {
      return onTheDateOfShipment
    }

    return `${sum} + ${onTheDateOfShipment}`
  }

  const getPreviousTotalQuantity = () => {
    const log = logs.find(x => x.event ===  BulkOrderLogEvent.Created)

    if (log === undefined) {
      return
    }

    const previous = (JSON.parse(log.currentValue).Fuels as IBulkOrderFuelLog[])

    return previous.reduce((partialSum, a) => partialSum + Number(a.Quantity), 0)
  }

  const getPreviousTotalOfferedPrice  = () => {
    const log = logs.find(x => x.event ===  BulkOrderLogEvent.Created)

    if (log === undefined) {
      return
    }

    const previous = (JSON.parse(log.currentValue).Fuels as IBulkOrderFuelLog[])

    const prices = previous.filter(x => x.OfferedPrice)
    const isContainsUndefined = previous.some(x => !x.OfferedPrice)
    const sum = prices.reduce((partialSum, a) => partialSum + (Number(a.OfferedPrice) * a.Quantity), 0)

    if (!isContainsUndefined) {
      return sum
    }

    if (!sum) {
      return onTheDateOfShipment
    }

    return `${sum} + ${onTheDateOfShipment}`
  }

  return (
    <>
      <Flex vertical={true} >
        <Text>
          <Text className={classes["text-base"]}>Количество сумма:</Text>
          <Text className={classes["text-base"]}>было</Text>
          <Text className={classes["text-base"]}>{getPreviousTotalQuantity()}</Text>
          <Text className={classes["text-base"]}>/</Text>
          <Text className={classes["text-now"]}>стало</Text>
          <Text className={classes["text-now"]}>{getCurrentTotalQuantity()}</Text>
        </Text>
        <Text className={classes["text-base"]}>
          <Text className={classes["text-base"]}>Сумма заказа:</Text>
          <Text className={classes["text-base"]}>было</Text>
          <Text className={classes["text-base"]}>{getPreviousTotalOfferedPrice()}</Text>
          <Text className={classes["text-base"]}>/</Text>
          <Text className={classes["text-now"]}>стало</Text>
          <Text className={classes["text-now"]}>{getCurrentTotalOfferedPrice()}</Text>
        </Text>
      </Flex>
    </>

  )
}

export default BulkOrderSummary
